export const TUTTI_HELPER = {
  version: '0.10.0',
  path: '/tutti-helper',
  storyPath: '/tutti-helper/story',
  privacyPath: '/tutti-helper/privacy',
  accountPath: '/tutti-helper/account',
  downloadUrl: '/downloads/tutti-activity-helper-v0.10.0.zip',
  referralUrl: 'https://tutti.so/join?ref=QMX2H4',
  paidPlansEnabled: false,
  sponsorshipUrl: 'https://ko-fi.com/peacetech',
  supportEmail: 'feedback@peacetech.app',
};
